import * as React from 'react';
import { Component } from 'react';
import propz from 'propz';
import { Switch } from '../Switch/Switch';
import { SimpleModal } from '../SimpleModal/SimpleModal';
import './IntegrationEditModal.scss';

interface Props {
  calendars: any[];
  isOpen: boolean;
  onButtonClick?: (selectCalendarsIds) => void;
  onCloseClick?: () => void;
}

interface State {
  calendars: any[];
}

export class IntegrationEditModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { calendars: propz.get(props, ['calendars'], []).map(calendar => ({ ...calendar })) };
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.calendars !== this.props.calendars || (!prevProps.isOpen && this.props.isOpen)) {
      this.setState({ calendars: (this.props.calendars || []).map(calendar => ({ ...calendar })) });
    }
  }

  onSubmit = () => {
    const selectedCalendarIds = this.state.calendars.filter(calendar => calendar.selected).map(calendar => calendar.id);
    if (this.props.onButtonClick) this.props.onButtonClick(selectedCalendarIds);
  };

  render() {
    const { isOpen, onCloseClick } = this.props;
    const { calendars } = this.state;
    if (!isOpen) return null;

    return (
      <SimpleModal
        isOpen={isOpen}
        title="Edit calendar integration"
        onCloseClick={onCloseClick}
        showFooter={false}
        customClass="integrationEditModal"
      >
        <div className="integrationCalendarForm">
          <p>Select the calendars whose events should be imported into Squad In Touch.</p>
          <div className="integrationCalendarForm__list">
            {calendars.map((calendar, index) => (
              <label key={calendar.id || index}>
                <span>
                  <strong>{calendar.name || 'Unnamed calendar'}</strong>
                  <small>{calendar.selected ? 'Events will be imported' : 'Not synchronised'}</small>
                </span>
                <Switch
                  value={calendar.selected}
                  onChange={() =>
                    this.setState({
                      calendars: calendars.map((item, itemIndex) =>
                        itemIndex === index ? { ...item, selected: !item.selected } : item
                      )
                    })
                  }
                  text=""
                  name={`calendar_${calendar.id || index}`}
                />
              </label>
            ))}
            {!calendars.length && (
              <div className="integrationCalendarForm__empty">No calendars are available for this account.</div>
            )}
          </div>
          <div className="integrationCalendarForm__actions">
            <button type="button" className="is-secondary" onClick={onCloseClick}>
              Cancel
            </button>
            <button type="button" className="is-primary" onClick={this.onSubmit} disabled={!calendars.length}>
              Save changes
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }
}
